import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { HttpClient } from '@angular/common/http';
import { catchError, map, type Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { type StopServiceRequest } from '../models/stop-service-request';
import { type Address } from '../models/address';
import { type SSMProcessData, type StartServiceRequest } from '../models/start-service';
import { Packages } from '../models/packages';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from './storage.service';
import { StorageEnum } from '../enums/storage.enum';
import { type DataViewerRequest } from '../models/smr-data-viewer-request';

@Injectable({
  providedIn: 'root',
})
export class StartStopMoveService {
  constructor(
    private readonly http: HttpClient,
    private readonly storage: StorageService,
  ) {}

  stopService(stopServiceRequest: StopServiceRequest): Observable<any> {
    const url = environment.OASUrl() + '/ssm/stop-service';
    const res = this.http.post(url, stopServiceRequest);
    return res.pipe(
      map((data: any) => {
        if (data.Status && data.Status === 'Success') {
          return data.Status;
        } else {
          throw new Error(data.Error?.ErrorCode);
        }
      }),
    );
  }

  getAddressByZip(zip: string): Observable<any> {
    const url = environment.OASUrl() + '/address/AGLAddressesByZip?zipCode=' + zip;
    const res = this.http.get(url);
    return res.pipe(
      map((data: any) => {
        if (data !== null && data.Response?.IsSuccessStatusCode === false) {
          throw new Error();
        } else {
          return data;
        }
      }),
      catchError((e) => {
        throw new Error(e);
      }),
    );
  }

  getAGLAddressList(address: Address): Observable<any> {
    const url = environment.OASUrl() + '/address/AGLPoolGroupByServiceAddress';
    const data = {
      address1: address.Address1,
      city: address.City,
      zipCode: address.PostalCode,
    };

    const res = this.http.post(url, data);
    return res.pipe(
      map((data: any) => {
        if (data !== null && data.Response?.IsSuccessStatusCode === false) {
          throw new Error();
        } else {
          return data;
        }
      }),
      catchError((e) => {
        throw new Error(e);
      }),
    );
  }

  getStartServiceRates(req: StartServiceRequest): Observable<Packages> {
    const url = environment.OASUrl() + '/ssm/start-service-rates';
    const res = this.http.post(url, req);
    return res.pipe(
      map((data: any) => {
        const resp = new Packages();
        resp.RatePackages = data.RatePackages;
        const ssmData: SSMProcessData = this.storage.getSession(StorageEnum.SSMData);
        ssmData.RatesResponse = data;
        this.storage.setSession(StorageEnum.SSMData, ssmData);
        return resp;
      }),
    );
  }

  saveStartMoveReconnectRequestToDataViewer(req: DataViewerRequest, userName: string): Observable<any> {
    const url = environment.OASUrl() + '/ssm/save-start-stop-move-requests?userName=' + userName;
    const res = this.http.post(url, req);

    return res.pipe(
      map((data: any) => {
        return data;
      }),
      catchError((e) => {
        throw new Error(e);
      }),
    );
  }

  sendStarMoveReconnectEmail(req: DataViewerRequest): Observable<any> {
    const url = environment.OASUrl() + '/ssm/sales-force-email-request';
    const res = this.http.post(url, req);
    return res.pipe(
      map((data: any) => {
        return data;
      }),
      catchError((e) => {
        throw new Error(e);
      }),
    );
  }
}
